import React from 'react';
import { Box } from '@mui/material';
import { Form, FormRenderProps } from 'react-final-form';

import { Button, Select, Typography } from '@occc-app/design-system';
import { Kiosk_Ad_Set_Status } from '@occc/graphql';

export type AdSetStatusType = '' | Kiosk_Ad_Set_Status;

export type AdSetFilterFormValues = {
  status: AdSetStatusType;
};

type AdSetsFilterFormProps = {
  status: AdSetStatusType;
  onSubmit: (values: AdSetFilterFormValues) => void;
  onReset: () => void;
  onClose: () => void;
};

// Status filter options
const statusFilterOptions = [
  { value: '', label: 'All Statuses' },
  { value: Kiosk_Ad_Set_Status.Published, label: 'Published' },
  { value: Kiosk_Ad_Set_Status.Draft, label: 'Draft' },
  { value: Kiosk_Ad_Set_Status.Archived, label: 'Archived' },
];

export const AdSetsFilterForm = ({ status, onSubmit, onReset, onClose }: AdSetsFilterFormProps) => {
  const handleSubmit = (values: AdSetFilterFormValues) => {
    onSubmit(values);
    onClose();
  };

  const handleReset = () => {
    onReset();
    onClose();
  };

  const renderForm: FormRenderProps<AdSetFilterFormValues>['render'] = ({
    handleSubmit,
    form,
  }: FormRenderProps<AdSetFilterFormValues>) => {
    const reset = () => {
      form.reset();
      handleReset();
    };

    return (
      <form onSubmit={handleSubmit}>
        <Box px={4} pt={4}>
          <Typography paragraph>Status</Typography>
          <Select
            name={'status' satisfies keyof AdSetFilterFormValues}
            label='Status'
            data={statusFilterOptions}
            displayEmpty
            inputLabelProps={{ shrink: true }}
          />
        </Box>
        <Box display='flex' justifyContent='flex-end' px={3} py={2}>
          <Button size='small' color='error' onClick={reset}>
            reset
          </Button>
          <Button type='submit' size='small' color='primary'>
            apply
          </Button>
        </Box>
      </form>
    );
  };

  return (
    <Form<AdSetFilterFormValues>
      render={renderForm}
      onSubmit={handleSubmit}
      initialValues={{ status }}
    />
  );
};
